// components/LSSF/RunningCompetitionList.jsx
import React from 'react';
import BaseList from './BaseList';

const RunningCompetitionList = () => {
  const columns = [
    { key: 'name', label: 'Name' },
    { key: 'age', label: 'Age' },
    { key: 'aadhar_number', label: 'Aadhar Number' },
    { key: 'school_college_id', label: 'School/College ID' },
    { key: 'parent_spouse_name', label: 'Parent/Spouse Name' },
    { key: 'phone', label: 'Phone' },
    { key: 'address', label: 'Address' },
    { 
      key: 'declaration', 
      label: 'Declaration',
      render: (value) => value ? 'Accepted' : 'Not Accepted'
    },
  ];

  return (
    <BaseList
      title="Running Competition Registrations"
      apiEndpoint="/api/v1/mail/running-competition-form"
      columns={columns}
      addButtonLink="/dashboard/lssf/add-running-competition"
      addButtonText="Add Registration"
    />
  );
};

export default RunningCompetitionList;